module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedExtraBold.cad5fc9.woff2";